/**
 * Derive a stable agent code slug from a display name.
 * Used while visibility is draft — never hand-edited by authors.
 */

export function slugifyAgentCode(name: string): string {
  const base = name
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .slice(0, 64);
  return base || 'UNTITLED_AGENT';
}
